import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
//import { CustomFormsModule } from 'ng2-validation'
import { DirectiveModule } from './directive';
import { PipesModule } from './pipes';
import { DialogModule } from './dialog/dialog.module';
// import { DeviceDetectorModule } from 'ngx-device-detector';

import { TiscoBlockCalculateLinkComponent } from './component/tisco-block-calculate-link/tisco-block-calculate-link.component';
import { TiscoCardComponent } from './component/tisco-card/tisco-card.component';
import { TiscoInformationComponent } from './component/tisco-information/tisco-information.component';
import { NissanInformationComponent } from './component/nissan-information/nissan-information.component';
import { TiscoIntroComponent } from './component/tisco-intro/tisco-intro.component';
import { TiscoIntroSlideComponent } from './component/tisco-intro-slide/tisco-intro-slide.component';
import { TiscoStepBuyComponent } from './component/tisco-step-buy/tisco-step-buy.component';
import { TiscoModalComponent } from './component/tisco-modal/tisco-modal.component';
import { ScrollTopComponent } from './component/scroll-top/scroll-top.component';
import { TiscoCarSliderComponent } from './component/tisco-car-slider/tisco-car-slider.component';
import { NgDataPickerComponent } from './component/ng-data-picker/ng-data-picker.component';
import { TiscoModalWaitingComponent } from './component/tisco-modal-waiting/tisco-modal-waiting.component';
import { Ng2SimpleAutocompleteComponent } from './component/ng2-simple-autocomplete/ng2-simple-autocomplete.component';
import { AutocompleteComponent } from './component/autocomplete/autocomplete.component';
import { CheckboxGroupComponent } from './component/checkbox/checkbox-group.component';
import { CheckboxComponent } from './component/checkbox/checkbox.component';
import { SimpleModalComponent } from './component/simple-modal/simple-modal.component';
import { TiscoConsentComponent } from './component/tisco-consent/tisco-consent.component';
import { ModalPermissionComponent } from '../shared/component/modal-permission/modal-permission.component';

const EXPORT_MODULE = [
    DirectiveModule,
    PipesModule,
    //CustomFormsModule,
    DialogModule
]

const EXPORT_COMPONENT = [
    TiscoBlockCalculateLinkComponent,
    TiscoCardComponent,
    TiscoInformationComponent,
    NissanInformationComponent,
    TiscoIntroComponent,
    TiscoIntroSlideComponent,
    TiscoStepBuyComponent,
    TiscoModalComponent,
    ScrollTopComponent,
    TiscoCarSliderComponent,
    NgDataPickerComponent,
    TiscoModalWaitingComponent,
    Ng2SimpleAutocompleteComponent,
    AutocompleteComponent,
    CheckboxGroupComponent,
    CheckboxComponent,
    SimpleModalComponent,
    TiscoConsentComponent,
    ModalPermissionComponent
]

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        // DeviceDetectorModule.forRoot(),
        ...EXPORT_MODULE
    ],
    declarations: [
        ...EXPORT_COMPONENT
    ],

    exports: [
        ...EXPORT_MODULE,
        ...EXPORT_COMPONENT
    ]
})
export class SharedModule { }
